import axios from 'axios';
import config from '../../config/config';
import {getCookie} from "../dom-utils";

let apiKey = "";

export function setApiKey(data) {
  apiKey = data;
}

export const isDevEnvironmentUrl = () =>
  !!window && window.location.hostname.toLowerCase().startsWith('wwwdev');

export const isStageEnvironmentUrl = () =>
  !!window && window.location.hostname.toLowerCase().startsWith('wwwstage');

function callApi(url, options = { method: 'get' }, isExternal = false, isMock= false, isPDF = false) {
  /* eslint-disable */
  const { NODE_ENV } = process.env;
  //const { baseEnvHost } = AXIOS_CONFIG_DATA;
  // const { apiKey, baseEnvHost } = AXIOS_CONFIG_DATA;
  const { method, requestBody } = options;
  const axiosConfig = {
    baseURL: window.location.host.includes('awstrp') ? config.api.internal : config.api.host,
    timeout: 60000,
    headers: {
      'apikey': apiKey,
      'accept': isPDF ? 'application/pdf' : 'application/json',
      'x-useragent': navigator.userAgent,
      'Content-Type': 'application/json',
      'access-control-allow-credentials': true,
      'x-trp-requested-with': 'XMLHttpRequest',
      'x-frame-options': 'SAMEORIGIN',
      'x-content-type-options': 'nosniff',
      'x-xss-protection': 1,
      'strict-transport-security': 'max-age=31536000; includeSubDomains',
      'TRP_CONSUMER_ID': 'ii-self-serve-ui',
      'import-oauth': window.location.host.includes('awstrp'),
      'trp-request-consumer-initial': 'ii-required-minimum-distribution-service'
    },
    data: {}
  };
  const consumerHeader = getCookie('trp-stage-routing');
  if (!!consumerHeader) {
    axiosConfig.headers[
      'trp-request-consumer-initial'
      ] = `ii-required-minimum-distribution-service-${consumerHeader}`;
  }

  if (NODE_ENV === 'development' && (method.toLowerCase() !== 'put' || method.toLowerCase() !== 'delete')) {
    const query = window.document.location.search;
    if (query.indexOf('?mocks=') >= 0 || isMock) {
      let urlQuery = '';
      if (url.indexOf('?') >= 0) {
        urlQuery = `&${url.split('?')[1]}`;
        url = url.split('?')[0];
      }
      const user = query.split('=')[1] || 'iowa';
      const option = urlQuery ? `/${urlQuery.split('=')[1]}` : '';
      axiosConfig.baseURL = '/';
      //url = `/mocks${url}${query}${urlQuery}`;
      url = `/mocks${url}${option}/${user}`;
      axiosConfig.headers['x-json-mocker'] = 'requested with mocks';
    } else {
      //axiosConfig.baseURL = `${baseEnvHost}${axiosConfig.baseURL}`;
    }
  }
  /* eslint-enable */
  if (NODE_ENV !== 'development') {
    // axiosConfig.baseURL = `${baseEnvHost}${axiosConfig.baseURL}`;
  }

  if (isExternal) {
    axiosConfig.baseURL = '';
  }
  const axiosInstance = axios.create(axiosConfig);
  axiosInstance.defaults.withCredentials = true;

  axiosInstance.interceptors.request.use(function (config) {
    // What to do before sending the request
    // Write a value to bypass if judgment
    if (config.method === 'get') {
      config.data = true
    }
    return config;
  }, function (error) {
    // What to do about request errors
    return Promise.reject(error);
  });
  const tempOption = isPDF ? { responseType: 'blob' } : {};
  return method.toLowerCase() === 'get'
    ? axiosInstance.get(url, tempOption).then((res) => res)
    : method.toLowerCase() === 'put'
      ? axiosInstance.put(url,  requestBody ).then((res) => res)
      : method.toLowerCase() === 'delete'
        ? axiosInstance.delete(url,  { data: requestBody } ).then((res) => res)
        : axiosInstance.post(url,  requestBody ).then((res) => res)
}

export default callApi;
